import React, { useEffect, useState } from 'react';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import ProfileComponent from '../profile/ProfileComponent';
import MenuOptionComponent from './MenuOptionComponent';
import './MenuStyle.css';

function MenuComponent() {
    const [collapsed, setCollapsed] = useState(true);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleNavbar = () => setCollapsed(!collapsed);

	return (
        <div>
            <Navbar id="menu-style" light expand={width > 1000}>
                <NavbarBrand href="/" className="me-auto" style={{
                    fontSize: '18px',
                    paddingRight: '9px'
                } }>
                    Inicio
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="me-2" />
                <Collapse isOpen={!collapsed} navbar>
                    <Nav  navbar>
                        <MenuOptionComponent value="Presupuesto" href="/user/budget" requireSession={true} /> 
                        <MenuOptionComponent value="Gastos" href="/user/expenses" requireSession={true} />
                        <MenuOptionComponent value="Medios de pago" href="/user/payments" requireSession={true} />
                        <MenuOptionComponent value="Financiamientos" href="/user/credits" requireSession={true} />
                        <MenuOptionComponent value="Nosotros" href="/about" requireSession={false} /> 
                        <MenuOptionComponent value="Contacto" href="/contact" requireSession={false} /> 
                    </Nav>
                </Collapse>
                <ProfileComponent></ProfileComponent>
            </Navbar>
        </div>
	);
}

export default MenuComponent;